import Constants from "@/utils/constants";

const routes = [
  {
    path: Constants.enums.ROUTE_ENUM.AUTH_CALLBAK_MOBILE_APP,
    component: () => import("@/pages/AuthCallback.vue")
  },
  {
    path: Constants.enums.ROUTE_ENUM.AUTH_CALLBAK,
    component: () => import("@/pages/AuthCallback.vue")
  },
  {
    path: Constants.enums.ROUTE_ENUM.HOME,
    component: () => import("@/pages/IndexPage.vue")
  },
  {
    path: Constants.enums.ROUTE_ENUM.LOG_IN,
    component: () => import("@/pages/SignInPage.vue")
  },
  {
    path: Constants.enums.ROUTE_ENUM.LOG_OUT,
    component: () => import("@/pages/logout/LogoutPage.vue")
  },
  {
    path: Constants.enums.ROUTE_ENUM.DASHBOARD + "/:id",
    component: () => import("@/pages/dashboard/DashboardPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    },
    props: (route) => ({
      ...route.params,
      ...route.query
    })
  },
  {
    path: Constants.enums.ROUTE_ENUM.FLRA_FORM,
    component: () => import("@/pages/forms/flra/FlraDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FLRA_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.FLRA_FORM + "/:id",
    component: () => import("@/pages/forms/flra/FlraDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FLRA_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.STATIC_FLHA_FORM + "/:id?",
    component: () => import("@/pages/forms/flha/FlhaFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.STATIC_FLHA_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.DEFECTS_FORM + "/:id?",
    component: () => import("@/pages/forms/defects/defectFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.DEFECTS_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.LWI_DASHBOARD,
    component: () => import("@/pages/dashboard/lwiDashboard/LWIDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.LWI_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.BLADES_SHOP_DASHBOARD,
    component: () => import("@/pages/forms/blades/bladeShopDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.BLADES_SHOP_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.MASTER_UNIT_DASHBOARD,
    component: () => import("@/pages/forms/blades/masterUnitDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.MASTER_UNIT_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.MASTER_INVENTORY_DASHBOARD,
    component: () =>
      import("@/pages/forms/blades/masterInventoryDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.MASTER_INVENTORY_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.INVENTORY_RECONCILIATION_DASHBOARD,
    component: () =>
      import("@/pages/forms/blades/inventoryReconciliationDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.INVENTORY_RECONCILIATION_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.PATROL_REPORT_DASHBOARD,
    component: () => import("@/pages/forms/report/patrolReportDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.PATROL_REPORT_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.PATROL_WEEKLY_REPORT_DASHBOARD,
    component: () =>
      import("@/pages/dashboard/lwiDashboard/PatrolWeeklyReportDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.PATROL_WEEKLY_REPORT_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.INSPECTION_FORM + "/:id?",
    component: () => import("@/pages/forms/inspections/inspectionFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.INSPECTION_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.SR_MANAGEMENT_FORM,
    component: () =>
      import("@/pages/forms/srManagement/SrManagementFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.SR_MANAGEMENT_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.SR_MANAGEMENT_FORM + "/:company",
    component: () =>
      import("@/pages/forms/srManagement/SrManagementFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.SR_MANAGEMENT_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    },
    beforeEnter: (to, from, next) => {
      const validCompanies = Object.values(Constants.enums.COMPANY_OPTIONS);
      if (!validCompanies.includes(to.params.company?.toUpperCase())) {
        next(Constants.enums.ROUTE_ENUM.ANONYMOUS);
      } else {
        next();
      }
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.DAILY_WORK_EXAMINATION_FORM,
    component: () =>
      import(
        "@/pages/forms/dailyWorkExamination/dailyWorkExaminationFormPage.vue"
      ),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.DAILY_WORK_EXAMINATION_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.DAILY_WORK_EXAMINATION_FORM + "/:company",
    component: () =>
      import(
        "@/pages/forms/dailyWorkExamination/dailyWorkExaminationFormPage.vue"
      ),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.DAILY_WORK_EXAMINATION_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    },
    // vue router guide that runs before accessing a specific route
    beforeEnter: (to, from, next) => {
      const validCompanies = Object.values(Constants.enums.COMPANY_OPTIONS);
      if (!validCompanies.includes(to.params.company?.toUpperCase())) {
        next(Constants.enums.ROUTE_ENUM.ANONYMOUS);
      } else {
        next();
      }
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.FORM_BUILDER,
    component: () => import("@/pages/admin/form/FormBuilderPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORMS_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.ADMIN + Constants.enums.ROUTE_ENUM.FORMS,
    component: () => import("@/pages/admin/form/FormsPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORMS_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.FORMS +
      "/:id",
    component: () => import("@/pages/admin/form/FormsPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORMS_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.FORM_TEMPLATES_DASHBOARD,
    component: () =>
      import("@/pages/admin/formTemplate/FormTemplateDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORM_TEMPLATES_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.FORM_TEMPLATES_RESPONSES,
    component: () =>
      import("@/pages/admin/formTemplate/FormTemplateReponsesDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORM_TEMPLATES_RESPONSES,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.FORM_TEMPLATE +
      "/:id?/:res?",
    component: () => import("@/pages/admin/formTemplate/FormTemplatePage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.FORM_SUBMISSION +
      "/:id?" +
      "/:itemId?",
    component: () => import("@/pages/admin/form/FormSubmissionPage.vue"),
    meta: {
      requiresAuth: true,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.SETTINGS,
    component: () => import("@/pages/settings/SettingsPage.vue"),
    meta: {
      requiresAuth: true,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.ADMIN + Constants.enums.ROUTE_ENUM.TAGS,
    component: () => import("@/pages/admin/tag/TagsPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.TAGS_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.SHIPPING_REQUEST_FORM + "/:id?",
    component: () =>
      import("@/pages/forms/shippingRequest/ShippingRequestFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.SHIPPING_REQUESTS_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.SHIPPING_REQUESTS_DASHBOARD + "/:id?",
    component: () =>
      import("@/pages/forms/shippingRequest/ShippingRequestsDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.SHIPPING_REQUESTS_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.TRIGGER_DASHBOARD,
    component: () =>
      import("@/pages/forms/triggerManagement/TriggerManagementDashboard.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.TRIGGER_MANAGEMENT_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.DYNAMIC_REPORT_FORM,
    component: () =>
      import("@/pages/forms/dynamicReport/dynamicReportFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "dashboard",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.DYNAMIC_REPORT_FORM,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path:
      Constants.enums.ROUTE_ENUM.ADMIN +
      Constants.enums.ROUTE_ENUM.TRIGGER_DASHBOARD +
      "/:id",
    component: () =>
      import("@/pages/forms/triggerManagement/TriggerFormPage.vue"),
    meta: {
      requiresAuth: true,
      permissionType: "form",
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.TRIGGER_MANAGEMENT_DASHBOARD,
      fallbackRoute: Constants.enums.ROUTE_ENUM.HOME
    }
  },
  {
    path: Constants.enums.ROUTE_ENUM.ANONYMOUS,
    component: () => import("@/pages/NotFoundPage.vue")
  },
  {
    path: Constants.enums.ROUTE_ENUM.PERMISSION_DENIED,
    component: () => import("@/pages/PermissionDeniedPage.vue")
  }
];

export default routes;
